import router, { INITIAL_ROUTE_NAME } from '@/router'
import { routes } from '@/config/routes'
import { microfrontends } from '@/config/microfrontends'
import { isLocalEnv } from '@/common/config'
import { envOverrides } from '@sennder/shell-utilities'
import { getRouteLocationName } from '@/modules/utils'

export const preloadMicrofrontend = async (path: string) => {
  const matchedRoute = router.resolve(path)

  const routeName = getRouteLocationName(matchedRoute) || INITIAL_ROUTE_NAME

  if (routeName) {
    const rawRoute = Object.values(routes).find((rawRoute) => {
      return rawRoute.name === routeName
    })

    if (rawRoute?.mf) {
      const mf = microfrontends[rawRoute?.mf]
      // Make sure not to preload if MF is overridden
      if (
        !envOverrides.isHot(mf.npmName) &&
        !envOverrides.isBranch(mf.npmName)
      ) {
        if (isLocalEnv()) {
          console.log(
            `[Shell] Preloading microfrontend ${mf.npmName} based on path ${path}`
          )
        }

        await mf.getMountFn()
      }
    }
  }
}
